import { AnalyticsPage, MessageMetricsTable, SentinelBreakdown, toMessageMetrics, toTableRows } from '@/modules/sentinel-analytics';
import { SENTINEL_TABLE_KEYS } from '@/modules/sentinel-analytics/metric-keys';
import type { SentinelMessageMetrics } from '@/types/sentinelAnalytics';

/** A row with no AI turns and no graded replies has every column empty; its tickets show on Ticket Metrics. */
const hasMessages = ({ messages }: { messages: SentinelMessageMetrics }) => messages.aiCoverage.total > 0 || messages.gradedDrafts > 0;

export default function MessageMetricsRoute() {
  return (
    <AnalyticsPage title='Message Metrics' tabs>
      {(query, dimension) => (
        <SentinelBreakdown query={query} keys={SENTINEL_TABLE_KEYS.messages} dimension={dimension} groupBys={{ category: [['category'], ['category', 'subcategory']], channel: [['channel']] }}>
          {([groups, subGroups = []]) => (
            <MessageMetricsTable
              nameLabel={dimension === 'channel' ? 'Channel Name' : 'Category Name'}
              rows={toTableRows(groups, dimension, subGroups, (get) => ({ messages: toMessageMetrics(get) }))
                .filter(hasMessages)
                .map((row) => ({ ...row, subRows: row.subRows.filter(hasMessages) }))}
            />
          )}
        </SentinelBreakdown>
      )}
    </AnalyticsPage>
  );
}
